import type { HTTPContentTypeCategory } from './http';

export const contentTypeCategoryToCodeLanguage: Record<
  Exclude<HTTPContentTypeCategory, 'image'>,
  string
> = {
  css: 'css',
  json: 'json',
  html: 'html',
  text: 'plaintext',
  javascript: 'javascript',
};
